import { render, staticRenderFns } from "./FormProductBrandComponent.vue?vue&type=template&id=753d9eb7&scoped=true"
import script from "./FormProductBrandComponent.vue?vue&type=script&lang=js"
export * from "./FormProductBrandComponent.vue?vue&type=script&lang=js"
import style0 from "./FormProductBrandComponent.vue?vue&type=style&index=0&id=753d9eb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753d9eb7",
  null
  
)

export default component.exports